import { PACKAGE_POPUP_TYPE, PACKAGE_STATUS } from "@elixir/types";
import { getDefaultPackage } from "@elixir/utils";
import dateFormat from "dateformat";
import { create } from "zustand";
import { TPackageBookingStore } from "./types";

const usePackageBookingStore = create<TPackageBookingStore>((set, get) => ({
  selectedPackageStatus: PACKAGE_STATUS.ONGOING,
  setSelectedPackageStatus: (selectedPackageStatus) => {
    set({ selectedPackageStatus });
  },

  selectedClinicId: undefined,
  setSelectedClinicId: (selectedClinicId) => set({ selectedClinicId }),

  showClinicSelector: false,
  setShowClinicSelector: (newVal) => set({ showClinicSelector: newVal }),

  selectedAppointment: undefined,
  setSelectedAppointment: (selectedAppointment) => set({ selectedAppointment }),

  packagePopupType: PACKAGE_POPUP_TYPE.NONE,
  setPackagePopupType: (packagePopupType) => set({ packagePopupType }),

  packageDetails: getDefaultPackage(),
  setPackageDetails: (packageDetails) =>
    set({ packageDetails: packageDetails || getDefaultPackage() }),

  sessionList: [],
  setSessionList: (sessionList) => set({ sessionList }),
  setSessionFromDateSelector: ({ slot, idx }) => {
    const { sessionList } = get();
    const newSessions = [
      ...sessionList.slice(0, idx),
      {
        ...sessionList[idx],
        date: dateFormat(slot.startTime, "mmmm dS, yyyy, h:MM TT"),
        dateContent: null,
        startTime: slot?.startTime,
        endTime: slot?.endTime,
      },
      ...sessionList.slice(idx + 1),
    ];
    set({
      sessionList: newSessions,
    });
  },

  setIncreaseSession: () => {
    const { sessionList } = get();
    const name = `Session ${sessionList.length + 1}`;
    const duration = "";
    const description = "";
    const date = "";
    const price = 0;

    set({
      sessionList: [
        ...sessionList,
        {
          name,
          date,
          description,
          duration,
          price,
        },
      ],
    });
  },
  setDecreaseSession: () => {
    const { sessionList } = get();
    set({
      sessionList: sessionList.slice(0, -1),
    });
  },

  showPlanAssignSuccessPopup: false,
  setShowPlanAssignSuccessPopup: (showPlanAssignSuccessPopup) =>
    set({ showPlanAssignSuccessPopup }),

  packageBookingColumnDefs: [],
  setPackageBookingColumnDefs: (packageBookingColumnDefs) =>
    set({ packageBookingColumnDefs }),

  treatmentTransactions: [],
  setTreatmentTransactions: (treatmentTransactions) =>
    set({ treatmentTransactions }),

  clearPackageDetails: () =>
    set({
      packageDetails: getDefaultPackage(),
      packagePopupType: PACKAGE_POPUP_TYPE.NONE,
      sessionList: [],
      selectedAppointment: undefined,
      transactionId: undefined,
      showClinicSelector: false,
      selectedClinicId: undefined,
    }),

  selectedPatient: undefined,
  setSelectedPatient: (patient) => set({ selectedPatient: patient }),

  setTransactionId: (id) => set({ transactionId: id }),

  conductingDoctor: undefined,
  setConductingDoctor: (conductingDoctor) => set({ conductingDoctor }),

  includeCompletedPackage: undefined,
  setIncludeCompletedPackage: (includeCompletedPackage) =>
    set({ includeCompletedPackage }),
}));

export default usePackageBookingStore;
